import { RoundedButton } from '@/components/rounded-button';
import { PopoverContent, PopoverRoot, PopoverTrigger } from '@/components/ui/popover';
import { getIconPathFromTokenSymbol } from '@/utils';
import { Button, Circle, HStack, Image } from '@chakra-ui/react';
import { useState } from 'react';
import { TiArrowSortedDown } from 'react-icons/ti';
import { TokenOption } from './types';

export const AssetSelect = ({
  selectedToken,
  setSelectedToken,
  tokenOptions,
}: {
  selectedToken: TokenOption | undefined;
  setSelectedToken: (s: TokenOption) => void;
  tokenOptions: TokenOption[];
}) => {
  const [open, setOpen] = useState(false);
  const selectToken = (token: TokenOption) => {
    setSelectedToken(token);
    setOpen(false);
  };
  return (
    <PopoverRoot open={open} onOpenChange={(e) => setOpen(e.open)}>
      <PopoverTrigger asChild>
        <RoundedButton
          h={10}
          bg="#F9F9F9"
          color="fg"
          disabled={tokenOptions.length <= 1}
          _hover={{ bg: '#F0F0F0' }}
          _disabled={{
            opacity: 1,
            bgColor: 'bg.muted',
            color: 'fg',
          }}
          px={2}
        >
          {selectedToken ? (
            <Image src={getIconPathFromTokenSymbol(selectedToken.symbol)} boxSize={6} />
          ) : (
            <Circle boxSize={6} bgColor="bg.muted" />
          )}
          <HStack gap={0}>
            {selectedToken?.symbol}
            {tokenOptions.length > 1 && <TiArrowSortedDown />}
          </HStack>
        </RoundedButton>
      </PopoverTrigger>
      <PopoverContent w="fit-content">
        {tokenOptions.map((token) => (
          <Button key={token.symbol} asChild variant="ghost" onClick={() => selectToken(token)} alignSelf="start">
            <HStack w="full" alignItems="center" justifyContent="flex-start">
              {token?.symbol && <Image src={getIconPathFromTokenSymbol(token.symbol)} boxSize={6} />}
              {token?.symbol}
            </HStack>
          </Button>
        ))}
      </PopoverContent>
    </PopoverRoot>
  );
};
